<template>
    <div>
        <rkm-timeline>
            <rkm-timeline-item
                v-for="(item, i) in data.additionals.timeline"
                :key="i"
                :dateTime="item.dateTime"
                :title="item.title"
                :label="item.label"
                :disabled="item.disabled"
                :line-class="getTimeLineClass(item, i)"
            />
        </rkm-timeline>

        <rkm-form ref="RkmForm">
            <box-paciente :data="data" disabled-acidente-trabalho />

            <box-classificacao-risco :data="data" />

            <box-dados-entrada :data="data" />

            <box-fator-risco :form="data.form" :model="data.model" />

            <box-alergia :data="data" />

            <box-medicamento-uso-continuo :data="data" />

            <box-medicamento-uso :data="data" />

            <box-sinal-vital
                :data="data"
                id="sinal-vital"
            />

            <rkm-row>
                <rkm-col :cols="showBoxGestante ? 7 : 12">
                    <box-avaliacao-antropometrica :data="data" />
                </rkm-col>

                <rkm-col
                    v-if="showBoxGestante"
                    cols="5"
                    id="gestante"
                >
                    <box-gestante :data="data" />
                </rkm-col>
            </rkm-row>

            <box-atendimento-medico
                :data="data"
                :visible="centroCusto.setor.tipoId !== enums.setorTipo.ENFERMAGEM && !data.additionals.isEnfermeiro"
                class="mb-3"
                readonly
            />

            <box-paciente-trauma
                :data="data"
                :disabled="data.additionals.isAuxiliarTecnicoEnfermagem"
                :visible="centroCusto.setor.tipoId !== enums.setorTipo.ENFERMAGEM && !data.additionals.isEnfermeiro"
                class="mb-3"
            />

            <box-avaliacao-trauma-parte-corpo
                :data="data"
                :disabled="data.additionals.isAuxiliarTecnicoEnfermagem"
                :visible="centroCusto.setor.tipoId !== enums.setorTipo.ENFERMAGEM && !data.additionals.isEnfermeiro"
            />

            <box-escala-coma-glasgow :data="data" />

            <box-anotacao-enfermagem
                :data="data"
                id="anotacao-enfermagem"
                class="mb-3"
            />

            <box-atendimento-enfermagem
                :data="data"
                :visible="data.additionals.isAuxiliarTecnicoEnfermagem
                    ? false
                    : (centroCusto.setor.tipoId === enums.setorTipo.ENFERMAGEM || !!data.additionals.isEnfermeiro)"
                class="mb-3"
                id="atendimento-enfermagem"
            />

            <box-exames
                :data="data"
                id="exame-Laboratorial"
            />

            <box-procedimento :data="data" />

            <box-servico-enfermagem
                :data="data"
                id="servico-enfermagem"
            />

            <box-prescricao-interna
                :data="data"
                :visible="centroCusto.setor.tipoId === enums.setorTipo.ENFERMAGEM || !!data.additionals.isEnfermeiro"
                id="prescricao-interna"
            />

            <box-protocolo :data="data" :disabled="true" v-if="data.model.dorToracica" />

            <rkm-fab-area>
                <rkm-fab
                    v-if="scY > 300"
                    @click="toTop"
                    icon="arrow-up"
                />
            </rkm-fab-area>
        </rkm-form>

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </div>
</template>

<script>
// Components.
import BoxPaciente from '@/components/pronto-atendimento/components/paciente/Index'
import BoxMedicamentoUsoContinuo from '@/components/cadastro/cidadao/components/medicamento-uso-continuo/Index'
import BoxClassificacaoRisco from '@/components/pronto-atendimento/components/classificacao-risco/Index'
import BoxDadosEntrada from './components/dados-entrada/Index'
import BoxFatorRisco from '@/components/cadastro/cidadao/components/fator-risco/Index'
import BoxAlergia from '@/components/cadastro/cidadao/components/alergia/Index'
import BoxMedicamentoUso from '@/components/pronto-atendimento/components/medicamento-uso/Index'
import BoxSinalVital from '@/components/pronto-atendimento/components/sinal-vital/Index'
import BoxAvaliacaoAntropometrica from '@/components/pronto-atendimento/components/avaliacao-antropometrica/Index'
import BoxGestante from '@/components/pronto-atendimento/components/gestante/Index'
import BoxAtendimentoMedico from '@/components/pronto-atendimento/components/atendimento/Index'
import BoxPacienteTrauma from './components/paciente-trauma/Index'
import BoxAvaliacaoTraumaParteCorpo from './components/avaliacao-trauma-parte-corpo/Index'
import BoxEscalaComaGlasgow from '@/components/pronto-atendimento/components/escala-coma-glasgow/Index'
import BoxAtendimentoEnfermagem from '@/components/pronto-atendimento/components/enfermagem/Index'
import BoxAnotacaoEnfermagem from '@/components/pronto-atendimento/components/anotacao-enfermagem/Index'
import BoxExames from '@/components/pronto-atendimento/components/exame/Index'
import BoxProcedimento from '@/components/pronto-atendimento/components/procedimento/Index'
import BoxProtocolo from '@/components/pronto-atendimento/components/protocolo/Index'
import BoxServicoEnfermagem from '@/components/pronto-atendimento/components/servico-enfermagem/Index'
import BoxPrescricaoInterna from '@/components/pronto-atendimento/components/prescricao-interna/Index'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import documentoTipo from '@/enums/cadastro/documentoTipo'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import sexo from '@/enums/cadastro/cidadao/sexo'
import tipoAtendimento from '@/enums/pronto-atendimento/parametrizacao/tipoAtendimento'
import tipoExame from '@/enums/parametrizacao/tipoExame'
import unidadeMedida from '@/enums/cadastro/unidadeMedida'
import statusExame from '@/enums/pronto-atendimento/statusExame'


// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Others.
import moment from 'moment'

// Mixins.
import { error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica } from '@/mixins'

export default {
    components: {
        BoxPaciente,
        BoxClassificacaoRisco,
        BoxDadosEntrada,
        BoxFatorRisco,
        BoxAlergia,
        BoxMedicamentoUsoContinuo,
        BoxMedicamentoUso,
        BoxSinalVital,
        BoxAvaliacaoAntropometrica,
        BoxGestante,
        BoxAtendimentoMedico,
        BoxPacienteTrauma,
        BoxAvaliacaoTraumaParteCorpo,
        BoxEscalaComaGlasgow,
        BoxAtendimentoEnfermagem,
        BoxAnotacaoEnfermagem,
        BoxExames,
        BoxProcedimento,
        BoxProtocolo,
        BoxServicoEnfermagem,
        BoxPrescricaoInterna,
    },
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    },
    created() {
        this.repositories.pacienteObservacao = this.getConectaSusRepository('prontoAtendimento.observacao')
    },
    data: () => ({
        repositories: {
            pacienteObservacao: null
        },
        enums: {
            desfecho,
            documentoTipo,
            setorTipo,
            sexo,
            tipoAtendimento,
            tipoExame,
            unidadeMedida,
            statusExame
        },
        model: {
            centroCustoParaId: null
        },
        scTimer: 0,
        scY: 0,
    }),
    computed: {
        ...mapGetters({ centroCusto: 'getCentroCusto' }),
        showBoxGestante() {

            if (this.data.form.paciente.isDesconhecido) {

                return false
            }

            return this.data.form.paciente.sexo.id === this.enums.sexo.FEMININO
                && this.data.form.paciente.idade.anos >= 9
                && this.data.form.paciente.idade.anos <= 60
        },
    },
    mixins: [error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        getTimeLineClass(item, i) {

            return item.listClass
                || this.data.additionals.timeline[i - 1] && this.data.additionals.timeline[i - 1].listClass
        },
        handleDesfecho() {

            if (this.data.model.finalizacao.desfechoId) {

                const confirm = async () => {

                    this.$nextTick().then(() => this.save())

                    return false
                }

                const desfecho = this.data.form.desfechos.find(desfecho => desfecho.id
                    == this.data.model.finalizacao.desfechoId).nome

                const msg = `O atendimento possui o desfecho <strong>${desfecho}</strong>. Se o atendimento for salvo
                    sem ser finalizado, qualquer alteração no desfecho não será registrada. Deseja continuar?`

                this.showConfirmation(msg, confirm)

                return false
            } else {

                this.save()
            }
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {

                const verificaHorario = this.data.model.pedidosExames.find(pedido => {
                    return pedido.exames.some(exame => {
                        return exame.status.id === 3 && !exame.horarioRealizacao;
                    });
                });

                if(verificaHorario){
                    this.showValidationNotification(
                        'Existe um ou mais procedimentos de Exame imagem/Laboratoriais que não possuem o horário preenchido.'
                    )

                    return false
                }

                const verificaProfissionalColeta = this.data.model.pedidosExames.find(pedido => {

                    return pedido.exames.some(exame => {
                        return exame.status.id === this.enums.statusExame.REALIZADO
                            && exame.exame.tipo.id == this.enums.tipoExame.EXAME_LABORATORIAL
                            && !pedido.usuarioId;
                    });
                });

                if(verificaProfissionalColeta){
                    this.showValidationNotification(
                        'É necessário informar o profissional responsável pela coleta.'
                    )

                    return false
                }

                const verificaProfissionalLaboratorio = this.data.model.pedidosExames.find(pedido => {

                    return pedido.exames.some(exame => {
                        return exame.status.id === this.enums.statusExame.REALIZADO
                            && exame.exame.tipo.id == this.enums.tipoExame.EXAME_LABORATORIAL
                            && !pedido.laboratorioUsuarioId;
                    });
                });

                if(verificaProfissionalLaboratorio){
                    this.showValidationNotification(
                        'É necessário informar o profissional responsável do laboratório.'
                    )

                    return false
                }

                if (response === true) {
                    if (this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }
                    else {
                        this.setLoading()

                        let request = {
                            plantaoId: this.plantaoId,
                            atendimentoId: this.data.form.atendimentoId,
                            classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                            aguardandoVagaHospitalar: this.data.model.aguardandoVagaHospitalar ? true : false,
                            quarto: this.data.model.quarto,
                            leito: this.data.model.leito,
                            alergias: this.data.model.alergias.map(item => {
                                return {
                                    alergiaId: item.alergia.id,
                                    criticidadeId: item.alergia.criticidade.id,
                                    reacoesObservacoes: item.alergia.reacoesObservacoes,
                                }
                            }),
                            medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => {
                                return {
                                    medicamentoId: item.medicamento.id,
                                }
                            }),
                            medicamentosUso: this.data.model.medicamentosUso,
                            sinaisVitais: this.data.model.sinaisVitais.map(item => {
                                return {
                                    pa: item.pa || null,
                                    paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                                    glicemia: item.glicemia || null,
                                    temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                                    pulso: item.pulso || null,
                                    respiracao: item.respiracao || null,
                                    saturacao: item.saturacao || null,
                                    intensidadeDor: item.intensidadeDor || null,
                                    cintura: item.cintura || null,
                                }
                            }),
                            gestacao: {
                                gestante: this.data.model.gestacao.gestante,
                                dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('DD/MM/YYYY') : null,
                            },
                            anotacoes: this.data.model.anotacoes.map(item => {
                                return {
                                    anotadoEm: item.dataHoraAnotacao,
                                    descricao: item.anotacao
                                }
                            }),
                            fatoresRisco: this.data.model.fatoresRisco,
                            fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                            avaliacao: this.data.model.avaliacao,
                            planejamento: this.data.model.planejamento,
                            implementacao: this.data.model.implementacao,
                            historico: this.data.model.historico,
                            diagnostico: this.data.model.diagnostico,
                            procedimentos: this.data.model.procedimentos.map(item => {
                                return {
                                    procedimentoId: item.procedimento.id,
                                    cidPrincipalId: item.cidPrincipal ? item.cidPrincipal.id : null,
                                    quantidade: item.quantidade,
                                }
                            }),
                            servicosEnfermagem: this.data.model.servicosEnfermagem.map(item => {
                                return {
                                    id: isNaN(item.id) ? null : item.id,
                                    statusId: item.status.id,
                                    procedimentoId: item.procedimento.id,
                                    cidId: item.cid ? item.cid.id : null,
                                    horarioRealizacao: item.horarioRealizacao,
                                    observacoes: item.observacoes,
                                }
                            }),
                            hemorragiaExternaGraveTraumaStatusId: this.data.model.hemorragiaExternaGraveTraumaStatusId,
                            hemorragiaExternaGraveLocal: this.data.model.hemorragiaExternaGraveLocal,
                            viasAeriasTraumaStatusId: this.data.model.viasAeriasTraumaStatusId,
                            viasAeriasObstrucaoPor: this.data.model.viasAeriasObstrucaoPor,
                            oxigenacaoRespiracaoVentilacaoTraumaStatusId: this.data.model.oxigenacaoRespiracaoVentilacaoTraumaStatusId,
                            pulsoTraumaStatusId: this.data.model.pulsoTraumaStatusId,
                            peleTraumaStatusId: this.data.model.peleTraumaStatusId,
                            peleAlteracao: this.data.model.peleAlteracao,
                            perfuracaoTraumaStatusId: this.data.model.perfuracaoTraumaStatusId,
                            perfuracaoLentificada: this.data.model.perfuracaoLentificada,
                            sangramentoTraumaStatusId: this.data.model.sangramentoTraumaStatusId,
                            sangramentoLocal: this.data.model.sangramentoLocal,
                            pupilasTraumaStatusId: this.data.model.pupilasTraumaStatusId,
                            paresiasTraumaStatusId: this.data.model.paresiasTraumaStatusId,
                            plegiaTraumaStatusId: this.data.model.plegiaTraumaStatusId,
                            exposicaoHipotermiaTraumaStatusId: this.data.model.exposicaoHipotermiaTraumaStatusId,
                            exposicaoHipotermiaObservacao: this.data.model.exposicaoHipotermiaObservacao,
                            avaliacaoCabecaPescoco: this.data.model.avaliacaoCabecaPescoco.avaliacaoCabecaPescoco,
                            avaliacaoTorax: this.data.model.avaliacaoTorax,
                            avaliacaoAbdome: this.data.model.avaliacaoAbdome,
                            avaliacaoMmssMmii: this.data.model.avaliacaoMmssMmii,
                            observacao: this.data.model.observacao,
                            escalaComaGlasgow: this.data.model.escalasComaGlasgow.map(item => {
                                return {
                                    aberturaOcularId: item.aberturaOcular.id,
                                    respostaVerbalId: item.respostaVerbal.id,
                                    respostaMotoraId: item.respostaMotora.id,
                                    reatividadePupilarId : item.reatividadePupilar.id,
                                    observacao: item.observacoes
                                }
                            })
                        }

                        request.prescricaoInternaAplicacoes = []

                        this.data.model.prescricoesInterna.forEach(prescricao => {

                            prescricao.medicamentos.forEach(medicamento => {

                                medicamento.aplicacoes.filter(a => !a.disabled).forEach(aplicacao => {

                                    request.prescricaoInternaAplicacoes.push({
                                        id: aplicacao.id,
                                        statusId: aplicacao.status.id,
                                        horarioAplicacao: aplicacao.horarioAplicacao,
                                        localAplicacaoId: aplicacao.localAplicacaoId,
                                    })
                                })
                            })
                        })

                        if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                            request.avaliacaoAntropometrica = {
                                massa: this.data.model.avaliacaoAntropometrica.massa,
                                massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                                alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                                altura: this.data.model.avaliacaoAntropometrica.altura,
                                alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                            }
                        }

                        request.pedidosExames = this.data.model.pedidosExames
                            .map(item => {
                                let exame = item.exames
                                    .map(exame => {
                                        const data = {
                                            id: exame.id,
                                            exameId: exame.exame.id,
                                            observacao: exame.observacao || null,
                                            statusId: exame.status.id,
                                            horarioRealizacao: exame.horarioRealizacao,
                                        }

                                        if(!item.id) {
                                            data.dataSolicitacao = moment(item.dataSolicitacao).format('DD/MM/YYYY')
                                            data.unidadeSolicitante = item.unidadeSolicitante
                                            data.medicoSolicitante = item.medicoSolicitante
                                        }

                                        return data
                                    })

                                return {
                                    isForm: item.isForm,
                                    id: item.id,
                                    urgente: item.urgente,
                                    justificativa: item.justificativa || null,
                                    usuarioId: item.usuarioId,
                                    laboratorioUsuarioId: item.laboratorioUsuarioId,
                                    ocupacaoId: item.ocupacaoId,
                                    laboratorioOcupacaoId: item.laboratorioOcupacaoId,
                                    usuarioInfraestruturaId: item.usuarioInfraestruturaId,
                                    laboratorioInfraestruturaId: item.laboratorioInfraestruturaId,
                                    exames: exame,
                                    files: item.files.filter(f => (f instanceof File)),
                                }
                            })

                        request.cancelamentoDesfecho = this.data.model.cancelamentoDesfecho

                        const formData = this.objectToFormData(this.camelObjectKeysToSnakeRecursive(request))

                        this.repositories.pacienteObservacao.store(formData)
                            .then(({ data }) => {

                                const finish = () => {

                                    this.$emit('save')
                                }

                                if (data.assinar) {

                                    this.afterSign = faaAssinada => {

                                        return this.repositories.pacienteObservacao.storeFaaAssinada(data.id, {
                                            faa_assinada: faaAssinada
                                        })
                                    }

                                    this.onSign = () => finish()
                                    this.onSkipSign = () => finish()

                                    this.askToSignAtendimento(
                                        async () => this.signFaa(
                                            data.atendimentoId,
                                            [{ tipo: 'observacao', id: data.id }],
                                            `faa-${data.faaId}-atendimento-observacao-${data.id}`
                                        ),
                                        async () => finish()
                                    )
                                }
                                else {

                                    this.showSaveNotification()

                                    finish()
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        handleScroll() {
            if (this.scTimer) return

            this.scTimer = setTimeout(() => {
                this.scY = window.scrollY

                clearTimeout(this.scTimer)

                this.scTimer = 0
            }, 100)
        },
        toTop() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
}
</script>